import * as React from 'react';

import { Binding } from 'core/infrastructure';
import { cloneExcept } from '../../utils';

import { FormComponent } from './Form';
import { Constraint } from './Constraints';
import * as Format from './Format';
import { DecimalBox, DecimalBoxCtor } from './DecimalBox';

interface Props<T> extends React.DetailedHTMLProps<React.InputHTMLAttributes<QuantityBox<T>>, QuantityBox<T>> {
	linkTo: Binding.PropertyPath<T>;
	allowNegative?: boolean;
	label?: string | React.ReactNode;
	rules?: Constraint | Constraint[];
	onEnterPress?: () => void;
	onValueChange?: (value: string) => void;
	boundValue?: any;
}

export class QuantityBox<T> extends React.Component<Props<T>, EmptyState> implements FormComponent {

	constructor(props: Props<T>) {
		super(props);
	}

	private textBox = React.createRef<DecimalBox<T>>();

	getPath() {
		return this.textBox.current!.getPath();
	}

	showErrors(errors: string[]) {
		this.textBox.current!.showErrors(errors);
	}

	getValue() {
		return this.textBox.current!.getValue();
	}

	setValue(value: number) {
		this.textBox.current!.setValue(value);
	}

	activate() {
		this.textBox.current!.activate();
	}

	render() {
		const TheTextBox: DecimalBoxCtor<T> = DecimalBox;

		const props = cloneExcept(this.props, ['ref']);
		props.precision = 3;
		props.format = Format.asDecimalWith(props.precision, false);

		return <TheTextBox ref={this.textBox} {...props} />;
	}
}

export type QuantityBoxCtor<T> = new (props: Props<T>) => QuantityBox<T>;
